module.exports = __webpack_public_path__ + "static/media/react-icon.8d859602.png";